import type { ErrorInfo, ReactNode } from 'react'
import { Component } from 'react'

type ErrorBoundaryProps = {
  children: ReactNode
  fallback: (error: unknown) => ReactNode
}

type ErrorBoundaryState = {
  error: unknown
  hasError: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { error: null, hasError: false }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return { error, hasError: true }
  }

  override componentDidCatch(error: unknown, errorInfo: ErrorInfo) {
    console.error('Uncaught error in React tree', error, errorInfo.componentStack)
  }

  override render() {
    if (this.state.hasError) {
      return this.props.fallback(this.state.error)
    }

    return this.props.children
  }
}
